import React from 'react';
import styled from "styled-components";
import colors from 'styles/colors';
import { canAccess } from 'utils/permissions';

const Container = styled.div`
  display: flex;
  width: 313px;
  height: 333px;
  padding: 48px 32px;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  border-radius: 16px;
  background: ${colors.white[200]};
  cursor: default;
  
  @media (max-width: 600px) {
    display: flex;
    max-width: 313px;
    height: 240px;
    padding: 48px 32px;
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }

  &:hover {
    color: ${colors.punch[800]};

    span {
      color: ${colors.punch[800]};
    }

    h5 {
      color: ${colors.punch[800]};
    }

    p {
      color: ${colors.punch[800]};
    }
  }

  span {
    font-size: 52px;
    color: ${colors.punch[600]};
  }
`;

const Text = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
  cursor: default;

  h5 {
    color: ${colors.punch[600]};
    font-family: Poppins;
    font-size: 24px;
    font-style: normal;
    font-weight: 700;
    line-height: 133.4%;
    align-self: stretch;
    cursor: default;
  }

  p {
    color: ${colors.punch[600]};
    font-family: "Source Sans Pro";
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 143%;
    letter-spacing: 0.17px;
    cursor: default;
  }
`;

const Card = ({ title, category, iconName, link, permissions, userRoles, onClick }) => {
  if (!canAccess(userRoles, permissions)) {
    return null;
  }

  const handleClick = () => {
    if (onClick) {
      onClick();
    } else if (link) {
      window.location.href = link;
    }
  };

  return (
    <Container onClick={handleClick}>
      <span className="material-symbols-rounded">{iconName}</span>
      <Text>
        <h5>{title}</h5>
        <p>{category}</p>
      </Text>
    </Container>
  );
};

export default Card;